import { render } from "./InnerCartonParamSettingButton.vue?vue&type=template&id=362ea773"
import script from "./InnerCartonParamSettingButton.vue?vue&type=script&lang=ts"
export * from "./InnerCartonParamSettingButton.vue?vue&type=script&lang=ts"

import "./InnerCartonParamSettingButton.vue?vue&type=style&index=0&id=362ea773&lang=less"
script.render = render

export default script